import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EdlCommonComponentsModule, EdlCommonDirectiveModule, EdlCommonPipesModule, EdlDatePickerModule, EdlEntriesModule, EdlUsersModule } from '@edl-development/edl-common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ErrorTailorModule } from '@ngneat/error-tailor';
import { LaddaModule } from 'angular2-ladda';
import { ComponentModule } from '../../components/components.module';
import { ComplyDirectivesModule } from '../../directives/comply-directives.module';
import { PipesModule } from '../../pipes/pipes.module';
import { ServiceModule } from '../../services/service.module';
import { ItemPacketFilterComponent } from './item-packet-filter/item-packet-filter.component';
import { ItemPacketActionsComponent } from './item-packet-actions/item-packet-actions.component';
import { ItemPacketItemSelectModalComponent } from './item-packet-item-select-modal/item-packet-item-select-modal.component';
import { ItemPacketPillColorSelectorComponent } from './item-packet-pill-color-selector/item-packet-pill-color-selector.component';
import { ItemPacketPillComponent } from './item-packet-pill/item-packet-pill.component';
import { ItemPacketPillsComponent } from './item-packet-pills/item-packet-pills.component';
import { ItemPacketStatusIndicatorComponent } from './item-packet-status-indicator/item-packet-status-indicator.component';
import { InComplianceStatusIndicatorComponent } from './in-compliance-status-indicator/in-compliance-status-indicator.component';



@NgModule({
    declarations: [
        ItemPacketPillComponent,
        ItemPacketPillsComponent,
        ItemPacketFilterComponent,
        ItemPacketActionsComponent,
        ItemPacketStatusIndicatorComponent,
        ItemPacketPillColorSelectorComponent,
        ItemPacketItemSelectModalComponent,
        InComplianceStatusIndicatorComponent
    ],
    exports: [
        ItemPacketPillComponent,
        ItemPacketPillsComponent,
        ItemPacketFilterComponent,
        ItemPacketActionsComponent,
        ItemPacketStatusIndicatorComponent,
        ItemPacketPillColorSelectorComponent,
        ItemPacketItemSelectModalComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }),
        EdlCommonDirectiveModule,
        ComplyDirectivesModule,
        LaddaModule,
        NgbModule,
        EdlCommonPipesModule,
        PipesModule,
        ComponentModule,
        EdlCommonComponentsModule,
        EdlDatePickerModule,
        EdlUsersModule,
        ServiceModule,
        ErrorTailorModule,
        EdlEntriesModule,
        NgSelectModule
    ]
})
export class ItemPacketsCommonModule { }
